import { writable } from 'svelte/store';
import * as entityStorage from './entities.js';

const myWorker = new Worker('../build/communities.js');

const ROLE_MAPPING = {
    ADMIN: 5,
    CURATOR_1: 4,
    CURATOR_2: 3,
    CURATOR_3: 2,
    USER: 1,
}

function createFeedStore() {
    const { subscribe, set, update } = writable({
        subscriptions: [],
        itemTagsMap: {},
        items: {},
        notes: {},
        tagCommunities: [],
        role: null,
        roleValue: null,
        currentUserID: null,
        isAuthenticated: false,
        globalChecks: {
            itemTags: false,
            noteTags: false,
        }
    });
    return {
        subscribe,
        set,
        update,
        addTaggedNoteEntities: ({ map, notesDict }) => {
            update(s => {
                if (s.globalChecks.noteTags) return s;
                entityStorage.addTaggedEntities(map);
                s.globalChecks.noteTags = true;
                s.notes = notesDict;
                return s;
            });
        },
        updateNoteContent: ({ noteID, noteUid, content }) => {
            update(s => {
                if (!content) return s;
                let note;
                const notesDict = s.notes;

                if (noteID) {
                    note = notesDict[noteID]
                } else if (noteUid) {
                    const key = notesDict[noteUid];
                    note = notesDict[key]
                }

                if (note) {
                    note.content = content;
                }

                return s;
            })
        },
        updateSubscriptionFeeds: ({ subscriptionID, feeds }) => {
            update(s => {
                // find bin sub,
                // console.log(s.subscriptions)
                const sub = s.subscriptions.find(sub => sub.subscription.id === subscriptionID);
                sub.subscription.feeds = feeds;

                s.subscriptions = s.subscriptions.map(subscription => (
                    subscription.subscription.id === sub.subscription.id 
                    ? sub 
                    : subscription
                ));

                // s.subscriptions = s.subscriptions.map(subscription => {
                //     if (subscription.subscription.id === subscriptionID) {
                //         subscription.subscription.feeds = feeds;
                //     }
                //     return subscription;
                // })

                return s;
            })
        },
        setFeed: (subscriptions, map, itemsDict) => {
            update(s => {
                s.subscriptions = subscriptions;
                s.itemTagsMap = map;
                s.items = itemsDict;

                // 1) create datascript db and add tags and items
                entityStorage.addItemEntities(itemsDict, subscriptions.map(s => s.subscription), Object.keys(map));
                s.globalChecks.itemTags = true;
                // console.log('entities added')

                // const b1 = new Date();
                // console.log('communities start', b1.getTime());
                // 2) create communities of tags
                myWorker.postMessage(s.itemTagsMap);

                try {
                    s.tagCommunities = JSON.parse(window.localStorage.getItem('communities') || '[]');
                } catch (e) {
                    s.tagCommunities = [];
                }
                
                // s.tagCommunities = bestCommunities.compute(s.itemTagsMap);
                // const b2 = new Date();
                // console.log('communities end', b2.getTime());
                // console.log('communities diff in seconds:', Math.abs(b1 - b2) / 1000);

                return s;
            });
        },
        updateAddItemTags: ({ itemID, tagNames }) => {
            update(s => {
                const item = s.items[itemID];
                if (item) {
                    const existingItemTags = new Set(item.tags)
                    const newItemTags = new Set(tagNames);

                    const toAdd = [...newItemTags].filter(tag => !existingItemTags.has(tag));
                    const toRemove = [...existingItemTags].filter(tag => !newItemTags.has(tag));

                    toAdd.forEach(tagToAdd => {
                        if (!(tagToAdd in s.itemTagsMap)) {
                            s.itemTagsMap[tagToAdd] = []
                        }
                        s.itemTagsMap[tagToAdd].push(`::${itemID}`)
                    });

                    toRemove.forEach(tagToRemove => {
                        if (tagToRemove in s.itemTagsMap) {
                            s.itemTagsMap[tagToRemove] = s.itemTagsMap[tagToRemove].filter(compoundKey => compoundKey.split(':')[2] !== itemID);
                            if (s.itemTagsMap[tagToRemove].length === 0) {
                                delete s.itemTagsMap[tagToRemove];
                            }
                        }
                    })

                    item.tags = tagNames
                }
                return s;
            })
        },
        setAuth: ({ isAuthenticated, role, currentUserID }) => {
            update(s => {
                if (typeof(isAuthenticated) == 'boolean') {
                    s.isAuthenticated = isAuthenticated;
                }
                if (role) {
                    s.role = role;
                    s.roleValue = ROLE_MAPPING[role];
                }
                if (currentUserID) {
                    s.currentUserID = currentUserID;
                }
                return s;
            })
        },
        addItems: ({ items }) => {
            update(s => {
                items.forEach(item => {
                    s.items[item.id] = item;
                })
                return s;
            })
        },
        updateItemTags: ({ itemIDs, tagsToAdd, tagsToRemove }) => {
            update(s => {
                itemIDs.forEach(itemID => {
                    let updatedTags = s.items[itemID].tags || [];
                    updatedTags = updatedTags.filter(tag => tagsToRemove.indexOf(tag) < 0);
                    s.items[itemID].tags = [...new Set([...updatedTags, ...tagsToAdd])];
                })
                return s;
            })
        }
        // getSubscriptions -> Object.entries(s.subscriptions)
        // addTag
        // addSubscription
        // addSubscriptionItem
    }
}

const feedStore = createFeedStore();

myWorker.onmessage = function(e) {
    feedStore.update(s => {
        s.tagCommunities = e.data || [];
        window.localStorage.setItem('communities', JSON.stringify(s.tagCommunities));
        return s;
    });
}

export default feedStore;